<template>
  <div>
    <custom-table :items="items" :headers="headers" :loading="loading">
      <template slot="actions" slot-scope="{item}">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
    </custom-table>
  </div>
</template>
<script>
import CustomTable from "../../../../components/CustomTable";
const API_ENDPOINT = "/api/formOfAddress";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean
    }
  },
  components: {
    CustomTable
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Code",
        value: "code",
        sortable: true
      },
      {
        text: "Description",
        value: "description",
        sortable: true
      }
    ],
    loading: false,
    search: "",
    footerProps: {
      rowsPerPageItems: [20, 50]
    }
  }),
  methods: {
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    //this.getAll();
  },
  mounted() {
    this.getAll();
  }
};
</script>